import React from 'react';
import config from '../../config';

const SiteSearchImage = ({ imageName }) => {
	return (
		<div className="image">
			<img
				src={ `${config.contentUrl}/product/sentrysafe/${imageName}` }
				alt={ imageName }
			/>
		</div>
	);
};

export default SiteSearchImage;


// WEBPACK FOOTER //
// ./src/pages/sitesearch/SiteSearchImage.js